import React, { MouseEvent, useCallback } from "react";

import { ICellRendererParams } from "@ag-grid-community/core";

import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";
import Activity from "@mapmycustomers/shared/types/entity/Activity";

import ActivityTypeChip from "@app/component/activity/ActivityTypeChip";

const ActivityTypeCellRenderer: React.FC<ICellRendererParams> = ({ context, data, value }) => {
  const handleClick = useCallback(
    (activityType: Pick<ActivityType, "id" | "name">, event: MouseEvent<HTMLElement>) => {
      context.onActivityTypeView?.(data, event.target);
    },
    [context, data]
  );

  return (
    <div>
      <ActivityTypeChip
        activityType={value as ActivityType}
        isAutoEmail={!!(data as Activity).emailLogId}
        onClick={handleClick}
        suppressTooltip
      />
    </div>
  );
};

export default ActivityTypeCellRenderer;
